import { useAuthStore } from '../../../store/authStore'
import { buildLoginUrl } from '../../../utils/redirectTo'
import { api } from '../api/api'

// Global refresh attempt counter
let refreshAttempts = 0

export const refreshAccessToken = async (): Promise<string | null> => {
  const { refreshToken, setToken, setRefreshToken, clearToken } = useAuthStore.getState()

  // Limit refresh attempts to 3
  if (refreshAttempts >= 3) {
    console.error('Maximum refresh attempts reached.')
    clearToken() // Clear tokens if limit is reached
    window.location.href = buildLoginUrl()
    return null
  }

  if (!refreshToken) {
    console.error('No refresh token available.')
    clearToken() // Clear tokens if no refresh token
    window.location.href = buildLoginUrl()
    return null
  }

  try {
    refreshAttempts += 1 // Increment attempt counter

    // Request a new access token using the refresh token
    const response = await api.post('/auth/token/refresh', {
      refresh_token: refreshToken,
    })

    const { access_token, refresh_token: newRefreshToken, token_type } = response.data

    // Update tokens in Zustand
    setToken(access_token, token_type)
    if (newRefreshToken) {
      setRefreshToken(newRefreshToken) // If backend returns a new refresh token
    }

    refreshAttempts = 0 // Reset counter if request was successful

    return access_token // Return the new access token
  } catch (error) {
    console.error('Failed to refresh access token:', error)
    clearToken() // Clear tokens if refresh fails
    window.location.href = buildLoginUrl()
    return null
  }
}
